import { StaticModal, createModal } from '@nexelem/modals';
import { useCustomTranslation } from '../../../../../hooks';
import { Button } from '@nexelem/components';
import { faBan, faCheckCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from 'react-i18next';

const MOCK_WORKSTATION = {
  name: 'Obszar fioletowy1',
  area: 'Obszar fioletowy',
  id: 'OBSZ_FIO1',
};

/* TODO: Add translation and correct data */
const EditAvailabilityModal = () => {
  const { t, tWrapper } = useCustomTranslation('products.productionPlan');

  return (
    <StaticModal maxWidth="lg" onClose={closeEditAvailabilityModal}>
      {/* // TODO: ADD correct dates */}
      <StaticModal.Header withCloseButton>{tWrapper('availabilityHours', { date: '1.04.2025' })}</StaticModal.Header>
      <StaticModal.Content className="scroll-stable pr-2">
        <div className="flex justify-between rounded-xs border border-border-container bg-surface-container-lighter px-4 py-3">
          <div className="flex flex-col gap-1">
            <span className="text-s16-sb">{MOCK_WORKSTATION.name}</span>
            <span className="text-s16 text-text-secondary-darker">{MOCK_WORKSTATION.id}</span>
          </div>
          <div className="flex items-center gap-2 self-start">
            <span className="text-s16-sb">{MOCK_WORKSTATION.area}</span>
            <div className="h-min-4 w-min-4 h-4 w-4 rounded-full bg-surface-action" />
          </div>
        </div>
        <div className="mt-6 text-s18">
          <Trans
            components={{
              icon1: <FontAwesomeIcon className="mx-0.5 text-icon-success" icon={faCheckCircle} />,
              icon2: <FontAwesomeIcon className="mx-0.5 text-icon-error" icon={faBan} />,
            }}
          >
            {tWrapper('editAvailabilityHours')}
          </Trans>
        </div>
      </StaticModal.Content>
      <StaticModal.Footer>
        <Button variant="outlined" onClick={closeEditAvailabilityModal}>
          {t('common.cancel')}
        </Button>
        <Button variant="contained">{t('common.save')}</Button>
      </StaticModal.Footer>
    </StaticModal>
  );
};

export const { openEditAvailabilityModal, closeEditAvailabilityModal } = createModal(EditAvailabilityModal, {
  name: 'EditAvailabilityModal',
});
